import { render, staticRenderFns } from "./widget_your_photo.vue?vue&type=template&id=2fdd4f3b&scoped=true&"
import script from "./widget_your_photo.vue?vue&type=script&lang=js&"
export * from "./widget_your_photo.vue?vue&type=script&lang=js&"
import style0 from "./widget_your_photo.vue?vue&type=style&index=0&id=2fdd4f3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd4f3b",
  null
  
)

export default component.exports